import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, Optional, Inject } from '@angular/core';
import * as c3 from 'c3';
import { BreakPointRegistry } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
import { CommonModule } from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatTableModule} from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'lib-chart-table',
  templateUrl: './chart-table.component.html',
  styleUrls: ['./chart-table.component.css'],
  standalone:true,
  imports:[
    CommonModule,
    DragDropModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
  ]
})
export class ChartTableComponent implements OnInit {
  showTableColumnsForWidget: string[] = [];
  showDataTableWidgetSource: any[];
  widgetPaginatorLength: any;
  showDataTableWidget: boolean;
  @Input() moduleName;
  toggleButtonValueV: any;

  constructor(@Optional() public dialogRef: MatDialogRef<ChartTableComponent>, private appAnalysisService: AppAnalysisService, private cdr: ChangeDetectorRef, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.chart = data.datatable[0]
    }
  }
  @Input() chart: any;
  @Output() deleteChartSuccess = new EventEmitter<any>();
  @Output() zoomgid = new EventEmitter<any>();

  ngOnInit() {

  }

  ngAfterViewInit() {
    console.log("data ==== ", this.chart);
    switch (this.chart.chart_type) {
      case "histogram": {
        this.getHistogramchart();
        break;
      }
      case "dataTable": {
        this.getDataTableChart();
        break;
      }
      case "feature_chart": {
        // this.getFeatureCountChart();
        break;
      }
      case "multi_layer_chart": {
        this.cdr.detectChanges();
        this.getMultipleLayerChart();
        break;
      }
      case "single_layer_chart": {
        this.getSingleLayerChart();
        break;
      }
    }
    this.cdr.detectChanges();
  }
  closeDialog() {
    this.dialogRef.close()
  }
  getDataTableChart() {
    if (this.chart.chart_data.data.length > 0) {
      let headers = Object.keys(this.chart.chart_data.data[0]);

      this.showTableColumnsForWidget = [];
      this.showTableColumnsForWidget = headers;
      this.showDataTableWidgetSource = this.chart.chart_data.data;
      this.widgetPaginatorLength = this.chart.chart_data.count
      this.showDataTableWidget = true
    }
    else {
      this.showDataTableWidgetSource = [];
      this.widgetPaginatorLength = 0;
    }
  }

  getMultipleLayerChart() {
    console.log("feature count chart ---- ", this.chart)

    let chartId;
    let chartData = this.chart.chart_data
    let label = this.chart.find_layer_attribute + " - " + this.chart.find_condition;
    let XAxisData = ['x'];
    let YAxisData = [label];
    chartData.forEach(element => {
      XAxisData.push(element.select_layer);
      YAxisData.push(element.find_layer);
    });
    let axisValue = [];
    axisValue.push(XAxisData);
    axisValue.push(YAxisData);
    chartId = this.chart.chartid
    let chart1 = c3.generate({
      bindto: '#chart_' + chartId,
      data: {
        x: 'x',
        columns: axisValue,
        keys: { value: ['count'] },
        type: 'bar',
      },
      title: {
        text: this.chart.chart_type,
      },
      axis: {
        x: {
          type: 'category',
          categories: XAxisData
        }
      },
      interaction: {
        enabled: this.chart.interactive_on
      }
    });

  }

  getSingleLayerChart() {
    let chartId;
    let chartData = this.chart.chart_data

    let XAxisData = ['x'];
    let YAxisData = [];
    let YAxis = this.chart.find_layer_attribute.split(",");
    for (let i = 0; i < YAxis.length; i++) {
      YAxisData.push([YAxis[i]])
    }

    let selectAttribute = this.chart.select_layer_attribute;

    chartData.forEach(element => {
      XAxisData.push(element[selectAttribute]);
      for (let i = 0; i < YAxis.length; i++) {
        YAxisData[i].push(element[YAxis[i]]);
      }
    });

    let finalColumns = [];
    finalColumns.push(XAxisData);
    for (let i = 0; i < YAxis.length; i++) {
      finalColumns.push(YAxisData[i])
    }

    chartId = this.chart.chartid
    c3.generate({
      bindto: '#chart_' + chartId,
      color: {
        pattern: ['#FABF62', '#ACB6DD']
      },
      data: {
        x: 'x',
        columns: finalColumns,
        type: 'bar'
      },
      title: {
        text: this.chart.chart_type.replace(/_/g, " ")
      },
      axis: {
        rotated: false,
        x: {
          type: 'category'
        }
      },
      interaction: {
        enabled: this.chart.interactive_on
      }

    });
  }

  // getFeatureCountChart(){

  // }

  drop(event) {

  }

  getHistogramchart() {
    let chartId;
    let chartData = this.chart.chart_data
    let label = this.chart.find_attribute;
    let XAxisData = ['x'];
    let YAxisData = [label];
    chartData = JSON.parse(chartData.count_array)
    chartData.forEach(element => {
      XAxisData.push(element.min + '-' + element.max)
      YAxisData.push(element.count)
    });
    let axisValue = [];
    axisValue.push(XAxisData);
    axisValue.push(YAxisData);
    chartId = this.chart.chartid
    let chart1 = c3.generate({
      bindto: '#chart_' + chartId,
      data: {
        x: 'x',
        columns: axisValue,
        keys: { value: ['count'] },
        type: 'bar',
      },
      title: {
        text: this.chart.chart_type
      },
      axis: {
        x: {
          type: 'category',
          categories: XAxisData,
          // label : {
          // text : 'Min & Max ',
          // position : 'outer-right'
          // }
        }
      },
      interaction: {
        enabled: this.chart.interactive_on
      }
    });
  }

  zoomToFeatureDataTable(gid) {
    this.zoomgid.emit(gid)
    this.dialogRef.close(gid)
  }



  deleteChart(chartId) {
    // this.appAnalysisService.deleteChart(chartId).subscribe(data => {
    //   if (data) {
        this.deleteChartSuccess.emit(chartId);
    //   }
    // });
  }

  interactiveChartToggle(toggleButtonValue, chartId) {
    this.toggleButtonValueV = toggleButtonValue
    let toggleButtonValue1 = Number(toggleButtonValue) // returns 1 if true and 0 if false
    this.appAnalysisService.updateInteractiveChartOn(chartId, toggleButtonValue1).subscribe(data => {
      console.log('----------------- Interactive chart Toggled on/off-------->', data);
      this.deleteChartSuccess.emit();
    });
  }
}